import React from 'react'
import { AppService } from 'src/services'
import { Container } from 'typescript-ioc'
import { FeedDetailsView } from '@pushly/aqe/lib/components/feeds/feed-details-view'
import { useActiveDomainChangeEffect } from '../../hooks/use-active-domain-change-effect'

export const FeedDetailsViewWrapper = (props: any) => {
    const appSvc: AppService = Container.get(AppService)

    const domainId = parseInt(props.match.params.domainId, 10)
    const feedId = parseInt(props.match.params.feedId, 10)

    const handleFeedClick = (notificationId: number) => {
        appSvc.routeWithinDomain(`/notifications/${notificationId}/summary`)
    }

    useActiveDomainChangeEffect((activeDomain, appService) => {
        appService.routeWithinDomain('/notifications/feeds')
    })

    return <FeedDetailsView domainId={domainId} feedId={feedId} handleFeedClick={handleFeedClick} />
}
